import { useMutation } from 'react-query'
import request from '../../request'
import { useDealership } from '../../../store/zustand/dealershipStore'

export const useUploadSoldReportsForDealership = () => {
  const dealership = useDealership()
  return useMutation(
    ({
      file,
      mapped_columns,
      customer_source_id,
    }: {
      file: File
      mapped_columns: any
      customer_source_id: string
    }) => {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('mapped_columns', JSON.stringify(mapped_columns))
      formData.append('customer_source_id', customer_source_id)
      return request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/upload`,
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
  )
}
